<!-- <div class="upload-container">
  <label>

    <input #inputField type="file" accept="image/jpeg, image/pjpeg, image/png" 
      (click)="inputField.value = ''" />

    <div class="image-preview">
      <img [src]="src" alt="">
    </div>

  </label>
</div> -->


<div class="form-group">
  <div class="upload-logo profile-img">
    <div class="image-upload">
      <label for="imageUpload">
        <input (change)="fileSelected($event)" accept="image/jpeg, image/pjpeg, image/png" class="img-viewer"
          id="imageUpload" type="file" />
        <div class="image-preview">
          <img *ngIf="src" [src]="src" />
        </div>
        <span class="plus-icon"></span>
      </label>
    </div>
  </div>
</div>